import { Injectable, computed, inject } from '@angular/core';
import { AspectCache, PrototypeCache } from '@xanadu/cache';

@Injectable({
    providedIn: 'root'
})
export class GraphQLSignal {
    private readonly prototypeCache = inject(PrototypeCache);
    private readonly aspectCache = inject(AspectCache);

    readonly prototypes = computed(() => {
        const prototypes = this.prototypeCache.signal();
        return prototypes ? [...prototypes.values()].filter(x => x.parentId && x.graphqlType?.length) : undefined;
    });

    readonly aspects = computed(() => {
        const aspects = this.aspectCache.signal();
        return aspects ? [...aspects.values()] : undefined;
    });

    readonly types = computed(() => {
        const aspects = this.aspects();
        const prototypes = this.prototypes();

        if (aspects && prototypes) {
            return [...aspects, ...prototypes];
        }

        return undefined;
    });
}
